import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { GameConfigType, GameType, UserType, PurchasesType } from "@/types";
import Api from "@/app/api/Api";
import Store from "@/app/store/Store";

Vue.config.productionTip = false;

const initialData: {
  api?: Api;
  config: GameConfigType;
  game?: GameType;
  initializing: boolean;
  purchases?: PurchasesType;
  store?: Store;
  user?: UserType;
} = {
  api: undefined,
  config: {
    maxPlayers: 10,
    minPlayers: 3,
    packs: [],
  },
  game: undefined,
  initializing: true,
  purchases: undefined,
  store: undefined,
  user: undefined,
};

// remove workers
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => {
      console.log(registrations);
      for (const registration of registrations) registration.unregister();
    })
    .catch((err) => console.log("Service Worker registration failed: ", err));
}

new Vue({
  render(h) {
    return h(App, {
      props: {
        config: this.config,
        game: this.game,
        initializing: this.initializing,
        purchases: this.purchases,
        user: this.user,
      },
    });
  },
  router,
  data: initialData,
  mounted() {
    this.initializing = true;
    // window.addEventListener("beforeunload", () => {});
    Api.initialize((user: UserType | null) => {
      this.initializing = false;
      if (!user) return;
      this.$set(this, "user", user);
      this.api = new Api(user.uid);
      this.store = new Store(this);
      this.store.initialize();
      if (!user.isAnonymous) this.store.purchasesInit();
    });
  },
  watch: {},
}).$mount("#app");
